import React, { useState } from 'react';
import { FormComponent, UiComponent } from 'components';
import { AttendanceStatusType, IEnroll } from 'types';

const OPTIONS: { name: string; value: AttendanceStatusType }[] = [
  { name: '출석', value: 'PRESENT' },
  { name: '지각', value: 'LATE' },
  { name: '결석', value: 'ABSENT' },
  { name: '취소', value: 'CANCEL' },
];

interface Props {
  targets: IEnroll[];
  isPending?: boolean;
  onSubmit: (attendanceStatus: AttendanceStatusType) => void;
}

function AttendanceStatusModal({ targets, isPending, onSubmit }: Props) {
  const [attendanceStatus, setAttendanceStatus] =
    useState<AttendanceStatusType>('PRESENT');

  return (
    <div css={{ minWidth: 'min(360px, 100%)' }}>
      <p css={{ fontSize: '13px', color: '#5f6069', marginBottom: '8px' }}>
        선택한 {targets.length}명의 출결상태를 변경합니다.
      </p>

      <div
        css={{
          maxHeight: '200px',
          overflowY: 'auto',
          padding: '12px',
          background: '#fafafa',
          borderRadius: '6px',
          marginBottom: '16px',
          fontSize: '13px',
          lineHeight: 1.6,
        }}
      >
        {targets.map(({ id, user }) => (
          <span key={id}>
            {user?.name}
            {id !== targets[targets.length - 1].id && ', '}
          </span>
        ))}
      </div>

      {attendanceStatus === 'CANCEL' && (
        <p css={{ fontSize: '12px', color: '#5f6069', marginBottom: '8px' }}>
          추첨형 봉사의 참여 확정자는 미선정으로 함께 변경됩니다.
        </p>
      )}

      <div css={{ display: 'flex', gap: '0 8px', justifyContent: 'flex-end' }}>
        <FormComponent.Select<AttendanceStatusType>
          css={{ width: '120px' }}
          options={OPTIONS}
          value={attendanceStatus}
          handleChange={setAttendanceStatus}
        />
        <UiComponent.Button
          color="primary"
          variant="contained"
          css={{ height: '35px' }}
          disabled={isPending}
          onClick={() => onSubmit(attendanceStatus)}
        >
          변경
        </UiComponent.Button>
      </div>
    </div>
  );
}

export default AttendanceStatusModal;
